import React from "react";
import SeatsLabels from '../SeatsSelection/SeatsLabels';
import CandybarOrderSummary from "../CandybarOrderSummary";

const getCandybarItemLabel = (item, orderItem) => {
    const label = [item.name];

    item.configs.forEach(config => {
        if (config.id in orderItem) {
            const orderConfig = orderItem[config.id];
            config.options.forEach(option => orderConfig.indexOf(option.id) > -1 && label.push(option.name));
        }
    });

    return label.join(' + ');
};

function CheckoutSidebarItemsBlock({ candybarOrder, candybarCatalog, seatsLabels, ticketsString }) {
    const ticketsBlock = TicketsSelection({ seatsLabels, ticketsString });
    const candybarBlock = CandybarSelection({ candybarOrder, candybarCatalog });

    if (!ticketsBlock && !candybarBlock) {
        return null;
    }

    return <>
        <hr className="mb-4 mt-0" />
        {ticketsBlock}
        {candybarBlock}
    </>;
}


function TicketsSelection({ seatsLabels, ticketsString }: { seatsLabels: string[]; ticketsString: string; }) {
    if (!ticketsString) {
        return null;
    }

    return (
        <div className="fade-in">
            <div className="row">
                <div className="col-4">
                    <h3 className="h6 small text-uppercase mt-1 mb-0">Boletos</h3>
                </div>
                <div className="col-8">
                    <p className="mb-0">{ticketsString}</p>
                </div>
            </div>
            {seatsLabels && seatsLabels.length ? <div className="row">
                <div className="col-4">
                    <h3 className="h6 small text-uppercase mt-1 mb-0">Asientos</h3>
                </div>
                <div className="col-8">
                    <SeatsLabels labels={seatsLabels.join(', ')} />
                </div>
            </div> : ''}
        </div>
    );
}

function CandybarSelection({ candybarOrder, candybarCatalog }) {
    const content = CandybarOrderSummary({
      candybarOrder,
      candybarCatalog
    });

    if (!content) {
      return '';
    }

    return (
        <div className="row fade-in">
            <div className="col-4">
                <h3 className="h6 small text-uppercase mt-1 mb-0">Dulcería</h3>
            </div>
            <div className="col-8">
                {content}
            </div>
        </div>
    );
}


export default CheckoutSidebarItemsBlock;
